import React from 'react';
import ViewRendering from '../components/ViewRendering';
import { renderingStuff, images } from '../utils';

export default function () {
	return (
		<div>
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'center'
				}}
			>
				<div>
					<h4 class="generalHead">Pastoral Dashboard</h4>
				</div>
			</div>
			<br />
			<ViewRendering
				centerWidth={'50%'}
				mainHeading={images.imgAcHead}
				data={renderingStuff.Pastrol_Dashboard_links}
				mainHead={false}
			/>
		</div>
	);
}
